// extracted by mini-css-extract-plugin
module.exports = {"appsPlaceholder":"WelcomeMessage_appsPlaceholder__2Art6","projectInfo":"WelcomeMessage_projectInfo__E3h89","mosaic_normal":"WelcomeMessage_mosaic_normal__sDOsi"};